import React from "react";

export function useFileContents(file: URL): string {
  const [output, setOutput] = React.useState('');

  React.useEffect(() => {
    fetch(file)
      .then(res => res.text())
      .then(text => {
        setOutput(text);
      });
  }, []);

  return output;
}